import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

declare const window: any;

export interface UploadedFile {
  fieldId: string; // ID поля формы
  file: string; // base64
  fileType: string; // mime type
  fileName: string;
  fileSize: number;
  filePath: string;
}

@Injectable({
  providedIn: 'root',
})
export class WebviewCommunicationService {
  private nsWebViewInterface: any;

  public isNsWebViewInterfaceInitialized$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this.loadNativescriptWebviewInterfaceScript().then(() => {
      this.initializeWebViewInterface();
    });
  }

  private loadNativescriptWebviewInterfaceScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `assets/webview/nativescript-webview-interface.js`;
      script.type = `text/javascript`;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = (error: any) => reject(error);
      document.body.appendChild(script); //Add the script to the body or head
    });
  }

  private initializeWebViewInterface(): void {
    // Check if we're actually inside NativeScript WebView (not just browser)
    // androidWebViewInterface exists only in real Android NativeScript WebView
    // For iOS WebView, check user agent (no Safari in WebView)
    const isInNativeScriptWebView =
      !!window.androidWebViewInterface || this.isIosNativeWebView();

    if (window.nsWebViewInterface && isInNativeScriptWebView) {
      this.nsWebViewInterface = window.nsWebViewInterface;
      this.isNsWebViewInterfaceInitialized$.next(true);
      console.log('nsWebViewInterface is available.');
    } else {
      console.log('Running in browser, nsWebViewInterface disabled.');
    }
  }

  private isIosNativeWebView(): boolean {
    const userAgent = navigator.userAgent || '';
    // iOS device but not Safari browser = WebView
    return /iPhone|iPad|iPod/.test(userAgent) && !/Safari/.test(userAgent);
  }

  public on(eventName: string, callback: (...args: any) => unknown): void {
    //Listen for messages from NativeScript
    if (this.nsWebViewInterface) {
      this.nsWebViewInterface.on(eventName, callback);
    }
  }

  public emit(handlerName: string, data: unknown): void {
    //Method to send messages to NativeScript
    if (this.nsWebViewInterface) {
      this.nsWebViewInterface.emit(handlerName, data);
    }
  }

  public callNativeHandler(
    functionCalledByNative: string,
    callback: () => unknown
  ): void {
    //function which can be called by native app
    window[functionCalledByNative] = callback;
  }

  public requestFileUpload(fieldId: string): void {
    if (this.nsWebViewInterface) {
      this.emit('uploadReceive', { fieldId });
    }
  }

  public onFileUploaded(callback: (data: UploadedFile) => void): void {
    this.on('uploadFile', callback);
  }
}
